import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import DefaultTopImage from '../../images/plans.svg'
import DefaultLab1 from '../../images/lab1.svg'
import DefaultLab2 from '../../images/lab2.svg'
import DefaultLab3 from '../../images/lab3.svg'
import { Services } from '../../api/Services'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useLanguage } from '../../context/LanguageContext'

const Registration = () => {
  const { language, translations, loading: translationsLoading, getImage } = useLanguage();
  const t = translations[language]?.registration || {};

  // Get images from API with fallbacks
  const attractFoodiesIcon = getImage('registration-attractFoodies');
  const fullControlIcon = getImage('registration-fullControl');
  const buildReputationIcon = getImage('registration-buildReputation');
  
  const [loading,setLoading]=useState(false)
  const [firstName,setFirstName]=useState('')
  const [lastName,setLastName]=useState('')
  const [email,setEmail]=useState('')
  const [phone,setPhone]=useState('')
  const [bestwaytocontact,setBestwaytocontact]=useState('')
  const [ownerormanager,setOwnerormanager]=useState('')
  const [businessPlan,setBusinessPlan]=useState('')
  const [restaurantName,setRestaurantName]=useState('')
  const [purposeOfContact,setPurposeOfContact]=useState('')
  const [restaurantAddress,setRestaurantAddress]=useState('')
  const [tableExpectation,settableExpectation]=useState('')
  const handlePlanChange = (event) => {
    setBusinessPlan(event.target.id); 
  };

  // Show loading while translations are being fetched
  if (translationsLoading) {
    return (
      <div className="why-avopla-container">
        <div className="parent-loader">
          <div className="_loader"></div>
        </div>
      </div>
    );
  }

  const registerFunction = async (data) => {
    let formData = new FormData()
    if(firstName){
      formData.append('first_name',firstName)
    }
    if(lastName){
      formData.append('last_name',lastName)
    }
    if(email){
      formData.append('email',email)
    }
    if(phone){
      formData.append('phone',phone)
    }
    if(bestwaytocontact){
      formData.append('best_way_to_contact',bestwaytocontact)
    }
    if(ownerormanager){
      formData.append('is_owner_or_manager',ownerormanager)
    }
    if(businessPlan){
      formData.append('fitting_business_plan',businessPlan)
    }
    if(restaurantName){
      formData.append('restaurant_name',restaurantName)
    }
    if(restaurantAddress){
      formData.append('restaurant_address',restaurantAddress)
    }
    if(purposeOfContact){
      formData.append('purpose_of_contact_us',purposeOfContact)
    }
    if(tableExpectation){
      formData.append('online_enable_table_expectation',tableExpectation)
    }
    setLoading(true)
try {
  const response =  await Services.registrationApi(formData);
  setLoading(false)
    
  
  // console.log(response);
  if(response.data.success === true){
    setFirstName('')
    setLastName('')
    setEmail('')
    setPhone('')
    setBusinessPlan('')
    setBestwaytocontact('')
    setOwnerormanager('')
    setRestaurantAddress('')
    setRestaurantName('')
    setPurposeOfContact('')
    settableExpectation('')
    
      toast.success(t.messages.success,{
          autoClose:1500,
          pauseOnHover:true,
          draggable:true,
          
        });
       
  }
  
  else{
    setLoading(false)
   
    toast.error(response?.data?.errors[0],{
      autoClose:2000,
      pauseOnHover:true,
      draggable:true,
      
    });
  }
  
} catch (error) {
  setLoading(false)

  
  console.log('rrr',error)
  toast.error(t.messages.error,{
    autoClose:2000,
    pauseOnHover:true,
    draggable:true,
    
  });
}

 

}

  return (
    <div className="why-avopla-container">
      <ToastContainer />
      {loading && <div className="parent-loader">
        <div className="_loader"></div></div>}
    <div className="main-header mb-40">
    <div className="container">
        <div className="contact-wrapper">
          <h2 className="title">
          {t.contact.title}
          </h2>
          <p className="subtitle">
          {t.contact.subtitle}
          </p>
          <p className="title-small">
          {t.contact.contactDetails}
          </p>
          <div className="row mb-4">
            <div className="col-12 col-md-6">
              <div className="form-group">
                <label htmlFor="">{t.contact.firstName} <sup>*</sup></label>
                <input type="text" value={firstName} onChange={(e)=>setFirstName(e.target.value)} placeholder={`${t.contact.firstName} *`} className="input" />
              </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="form-group">
                <label htmlFor="">{t.contact.lastName} <sup>*</sup></label>
                <input type="text" value={lastName} onChange={(e)=>setLastName(e.target.value)} placeholder={`${t.contact.lastName} *`} className="input" />
              </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="form-group">
                <label htmlFor="">{t.contact.email} <sup>*</sup></label>
                <input type="text" value={email} onChange={(e)=>setEmail(e.target.value)} placeholder={`${t.contact.email} *`} className="input" />
              </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="form-group">
                <label htmlFor="">{t.contact.phone} <sup>*</sup></label>
                <input type="text" value={phone} onChange={(e)=>setPhone(e.target.value)} placeholder={`${t.contact.phone} *`} className="input" />
              </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="form-group">
                <label htmlFor="">{t.contact.bestWay}</label>
                <select name="" value={bestwaytocontact} onChange={(e)=>setBestwaytocontact(e.target.value)} id="" className="input">
                <option value="">{t.contact.selectPlaceholder}</option>
                  <option value="By Email">{t.contact.byEmail}</option>
                  <option value="By Phone">{t.contact.byPhone}</option>
                </select>
              </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="form-group">
                <label htmlFor="">{t.contact.ownOrManage}</label>
                <select name="" value={ownerormanager} onChange={(e)=>setOwnerormanager(e.target.value)} id="" className="input">
                <option value="">{t.contact.selectPlaceholder}</option>
                  <option value="Yes">{t.contact.yes}</option>
                  <option value="No">{t.contact.no}</option>
                </select>
              </div>
            </div>
            
          </div>
          <div className="custom-radio-wrapper">
            <span className="title">
            {t.contact.whichPlan}
            </span>
            <div className="right">
              <div className="custom-radio">
                <input type="radio" onChange={handlePlanChange}
          checked={businessPlan === 'basic'} name="plan" id="basic" />
                <label htmlFor="basic">{t.contact.basicPlan}</label>
              </div>
              <div className="custom-radio">
                <input type="radio" onChange={handlePlanChange}
          checked={businessPlan === 'premium'} name="plan" id="premium" />
                <label htmlFor="premium">{t.contact.premiumPlan}</label>
              </div>
            </div>

          </div>
          <p className="title-small">
          {t.contact.restaurantDetails}
          </p>
          <div className="row mb-4">
            <div className="col-12 col-md-6">
              <div className="form-group">
                <label htmlFor="">{t.contact.restaurantName} <sup>*</sup></label>
                <input type="text" value={restaurantName} onChange={(e)=>setRestaurantName(e.target.value)} placeholder={`${t.contact.restaurantName} *`} className="input" />
              </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="form-group">
                <label htmlFor="">{t.contact.restaurantAddress} <sup>*</sup></label>
                <input type="text" value={restaurantAddress} onChange={(e)=>setRestaurantAddress(e.target.value)} placeholder={`${t.contact.restaurantAddress} *`} className="input" />
              </div>
            </div>
            
            <div className="col-12 col-md-6">
              <div className="form-group">
                <label htmlFor="">{t.contact.purpose}</label>
                <select name="" value={purposeOfContact} onChange={(e)=>setPurposeOfContact(e.target.value)} id="" className="input">
                <option value="">{t.contact.selectPlaceholder}</option>
                  <option value="I want to learn about Avopla">{t.contact.learnAbout}</option>
                  <option value="I want to schedule a demo">{t.contact.scheduleDemo}</option>
                </select>
              </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="form-group">
                <label htmlFor="">{t.contact.howManyTables}</label>
                <select name="" value={tableExpectation} onChange={(e)=>settableExpectation(e.target.value)} id="" className="input">
                  <option value="">{t.contact.selectPlaceholder}</option>
                  <option value="5-10">{t.contact.tables5_10}</option>
                  <option value="11-20">{t.contact.tables11_20}</option>
                  <option value="21 +">{t.contact.tables21plus}</option>
                </select>
              </div>
            </div>
            
          </div>
          <div className="d-flex justify-content-end">
            <button className="button" onClick={registerFunction}>
              {t.contact.submit}
            </button>
          </div>
        </div>
      </div>
      </div>
      <div className="container">
        <div className="bottom-contact-text">
          <h3 className="title">
            {t.whyPartner?.title}
          </h3>
          <div className="row">
            <div className="col-12 col-md-6 col-lg-4">
              <div className="item">
                <div className="image">
                <img 
                  src={attractFoodiesIcon?.url || DefaultLab1} 
                  alt={attractFoodiesIcon?.alt || "Attract more foodies"} 
                />
                </div>
                <h4 className="label">
                  {t.whyPartner?.item1?.label}
                  </h4>
                  <p className="text">
                    {t.whyPartner?.item1?.text}
                  </p>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <div className="item">
                <div className="image">
                <img 
                  src={fullControlIcon?.url || DefaultLab2} 
                  alt={fullControlIcon?.alt || "Get full control"} 
                />
                </div>
                <h4 className="label">
                {t.whyPartner?.item2?.label}
                  </h4>
                  <p className="text">
                    {t.whyPartner?.item2?.text}
                  </p>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <div className="item">
                <div className="image">
                <img 
                  src={buildReputationIcon?.url || DefaultLab3} 
                  alt={buildReputationIcon?.alt || "Build your reputation"} 
                />
                </div>
                <h4 className="label">
                 {t.whyPartner?.item3?.label}
                  </h4>
                  <p className="text">
                   {t.whyPartner?.item3?.text}
                  </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      
    </div>
  )
}

export default Registration